// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectTradingSystemRemoveMessage } from '@shared/utils/DirectMessages/DirectTradingSystemRemoveMessage';
export class TradingSystemRemoveMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectTradingSystemRemoveMessage();
        message.ID = fieldSet.GetValue(FieldsFactory.FIELD_TRADING_SYSTEM_ID);
        return [message];
    }
}
